export enum TimepickerClockType {
  HOURS = 'hours',
  MINUTES = 'minutes'
}
